export default "__VITE_ASSET__DJ5MfQBu__"